import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { OfferStack } from '../components/OfferStack';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PriceBlock } from '../components/PriceBlock';
export function SalesPage() {
  return <main className="min-h-screen bg-[#0a0f1a] text-gray-100 font-sans selection:bg-emerald-500/30 selection:text-emerald-200" data-id="element-192">
      {/* Hero - Darkest */}
      <div className="bg-[#0a0f1a]" data-id="element-193">
        <HeroSection data-id="element-194" />
      </div>

      {/* Problem - Slightly lighter */}
      <div className="bg-[#0d1321]" data-id="element-195">
        <ProblemSection data-id="element-196" />
      </div>

      {/* Failed Solutions - Darkest */}
      <div className="bg-[#0a0f1a]" data-id="element-197">
        <FailedSolutions data-id="element-198" />
      </div>

      {/* Mechanism - Tech accent background */}
      <div className="bg-gradient-to-b from-[#0a0f1a] to-[#0d1321]" data-id="element-199">
        <MechanismSection data-id="element-200" />
      </div>

      {/* Offer Stack - Lighter */}
      <div className="bg-[#111827]" data-id="element-201">
        <OfferStack data-id="element-202" />
      </div>

      {/* Audience - Darkest */}
      <div className="bg-[#0a0f1a]" data-id="element-203">
        <AudienceSection data-id="element-204" />
      </div>

      {/* How it works - Lighter */}
      <div className="bg-[#0d1321]" data-id="element-205">
        <HowItWorks data-id="element-206" />
      </div>

      {/* Proof - Darkest */}
      <div className="bg-[#0a0f1a]" data-id="element-207">
        <ProofSection data-id="element-208" />
      </div>

      {/* FAQ - Lighter */}
      <div className="bg-[#111827]" data-id="element-209">
        <FAQSection data-id="element-210" />
      </div>

      {/* Price Block - Darkest with glow */}
      <div className="bg-[#0a0f1a]" data-id="element-211">
        <PriceBlock data-id="element-212" />
      </div>

      {/* Footer */}
      <footer className="bg-[#05080f] py-8 text-center text-gray-600 text-sm" data-id="element-213">
        <p data-id="element-214">
          © {new Date().getFullYear()} Freelance Express. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}